import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import "./Recommendation.scss";
import RecommendationsCarousel from "./RecommendationsCarousel";

const Recommendation = ({
  data,
  isRecommendationsShown,
  onClick,
  enableAddressSelection,
  removeRecommendedItem,
  recommendationDetails,
  cantSuggestRecommendation,
  handleSuggestBtn,
}) => {
  return (
    <div className="recommendationContainer">
      {isRecommendationsShown && (
        <div className="close-btn" onClick={onClick}>
          <img src={require("@images/arrow_down.svg")} />
        </div>
      )}
      <div className="header">
        <div>
          <img src={require("@images/recommendation.svg")} alt="reco_icon" />
          <div>
            <p className="heading">
              {isRecommendationsShown
                ? data.heading
                : "Order discounted health care products"}
            </p>
            <p className="subHeading">
              {recommendationDetails.amountForFreeDC &&
              recommendationDetails.amountForFreeDC > 0 ? (
                <span>
                  Add Items worth ₹{recommendationDetails.amountForFreeDC} more
                  to unlock <strong>FREE Delivery</strong>
                </span>
              ) : (
                ""
              )}
            </p>
          </div>
        </div>
        <div>
          {isRecommendationsShown ? (
            <div
              className={cx("cantSuggestCard", {
                responded: cantSuggestRecommendation,
              })}
              onClick={handleSuggestBtn}
            >
              <img
                src={
                  cantSuggestRecommendation
                    ? require("@images/available.svg")
                    : require("@images/thumb_down_red.svg")
                }
              />
              <span>
                {cantSuggestRecommendation
                  ? "RESPONSE NOTED"
                  : "COULD NOT SUGGEST"}
              </span>
            </div>
          ) : (
            <button onClick={onClick} className="recommendationsButton">
              Show Products
            </button>
          )}
        </div>
      </div>
      {isRecommendationsShown && (
        <RecommendationsCarousel
          recommendedItems={data.products}
          numberOfRecommendations={data.products.length}
          removeRecommendedItem={removeRecommendedItem}
          enableAddressSelection={enableAddressSelection}
          widgetId={data.widgetId}
        />
      )}
    </div>
  );
};

Recommendation.propTypes = {
  data: PropTypes.object.isRequired,
  isRecommendationsShown: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  enableAddressSelection: PropTypes.func.isRequired,
  removeRecommendedItem: PropTypes.func.isRequired,
  recommendationDetails: PropTypes.object.isRequired,
};

export default Recommendation;
